import React from 'react';
import { useParams } from 'react-router-dom';
import { TypedMemo } from '../../../common/types';
import { LoadingView } from '../../../common/views/LoadingView';
import { useAccountId } from '../../../../redux/slices/appInfo/hooks';
import { CampaignLiveScreen } from './CampaignLiveScreen';

/** The route `/outreach/campaigns/:campaignUuid` (design t1, t2). */
const CampaignLiveViewComponent: React.FC = () => {
  const accountId = useAccountId();
  const { campaignUuid } = useParams<{ campaignUuid: string }>();
  if (accountId === null || campaignUuid === undefined) {
    return <LoadingView />;
  }
  return <CampaignLiveScreen accountId={accountId} campaignUuid={campaignUuid} />;
};

export const CampaignLiveView = TypedMemo(CampaignLiveViewComponent);
